import React from "react";
import "./styles.css";
/**
 * @function ContentHeaderView
 * @param {STRING} className - Allows us to set a className to add bottom border. 
 * @param {STRING} text - String to show the header of the content in widgets and pages. 
 * @param {STRING} data-point - The data point that should be added to the header
 * @returns {React.Component}
 * @example
 * <ContentHeaderView className="some-class" text="Content header text" />
 */
export default function ContentHeaderView(props) {
  const className = props.className ?? "";
  const text = props.text ?? "" ;
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

  return (
    <div className={`${className} content-header`} >
      <span data-point={ point }>{text}</span>
    </div>
  );
}